export default __webpack_public_path__ + "static/media/ThinkInsurance.cd322286102e39e1a16b803870406d1f.webp";